import * as React from 'react'
import { useTheme } from 'styled-components'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { Alert } from '../../../../../brunswick/components/Alert'
import { ModalCloseButton } from '../../../../../brunswick/components/ModalCloseButton'
import {
  modalAnimationDuration,
  standardModalBodyOpenClassName,
  standardModalPortalClassName,
} from '../../../../../brunswick/styles/constants'
import { trackEvent } from '../../../../../lib/analytics'
import { NextModal } from '../../../../modals/NextModal'
import { WaitlistService } from '../contexts/WaitlistService'

import { Divider, Headline, Instructions, ProductTitle, deriveModalStyles } from './styles'
import { WaitlistForm } from './WaitlistForm'

export interface WaitlistModalProps {}

export const WaitlistModal: React.FC<WaitlistModalProps> = () => {
  const { waitlist: waitlistCopy } = useTranslation()

  const theme = useTheme()

  const {
    closeWaitlistModal,
    currentColorKey,
    errorMessage,
    productTitle,
    shouldDisplayWaitlistModal,
    successMessage,
  } = WaitlistService.useContainer()

  return (
    <NextModal
      bodyOpenClassName={standardModalBodyOpenClassName}
      closeTimeoutMS={modalAnimationDuration}
      isOpen={shouldDisplayWaitlistModal}
      onRequestClose={closeWaitlistModal}
      portalClassName={standardModalPortalClassName}
      style={deriveModalStyles(theme)}
    >
      <ModalCloseButton
        onClick={closeWaitlistModal}
        {...trackEvent({
          category: 'waitlist',
          action: 'waitlist modal - close',
        })}
      />
      <Headline textType='h1' textTransform='uppercase'>
        {waitlistCopy.modal.headline}
      </Headline>
      <Instructions>{waitlistCopy.modal.instructions}</Instructions>
      <Divider />
      <ProductTitle textType='h2'>
        {currentColorKey} {productTitle}
      </ProductTitle>
      {!successMessage && <WaitlistForm />}
      {errorMessage && <Alert severity='error'>{errorMessage}</Alert>}
      {successMessage && <Alert severity='success'>{successMessage}</Alert>}
    </NextModal>
  )
}

export default WaitlistModal
